import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class FactorCoefficientRangeModule {
}
FactorCoefficientRangeModule.ɵfac = function FactorCoefficientRangeModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FactorCoefficientRangeModule)(); };
FactorCoefficientRangeModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FactorCoefficientRangeModule });
FactorCoefficientRangeModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
